import { html } from "htm/preact";
import { useState } from "preact/hooks";
import { AH } from "../component_map";

import { Dropdown } from "../new/dropdown";
import { OverlaySlideDown, LoginOverlaySlide, LanguageSlider, MobileMenu } from "../new/overlay-slider";
import { GlobeIcon, GridIcon, PersonIcon, CloseIcon, MenuIcon } from "../new/icons";

export const NavigationBar = () => {
  const [activeSlideDown, setActiveSlideDown] = useState(0);
  const [isSlideActive, setSlideActive] = useState(false);
  const mapping = {
    0: {
      name: "Language Slider",
      content: html`<${LanguageSlider} />`,
    },
    1: {
      name: "Login Slider",
      content: html`<${LoginOverlaySlide} />`,
    },
    2: {
      name: "Mobile Menu",
      content: html`<${MobileMenu} setActiveSlideDown="${setActiveSlideDown}" setSlideActive="${setSlideActive}" />`,
    },
  };
  return html`
    <header className="relative bg-black text-primary-100 z-50">
      <div className="max-w-6xl mx-auto px-5 py-3 flex items-center justify-between">
        <${BlockLeft} />
        <${BlockRight}
          isSlideActive="${isSlideActive}"
          setActiveSlideDown="${setActiveSlideDown}"
          setSlideActive="${setSlideActive}"
        />
      </div>
    </header>
    <${OverlaySlideDown} isActive="${isSlideActive}" setActive="${setSlideActive}">
      ${mapping[activeSlideDown].content}
    <//>
  `;
};

const BlockLeft = () => {
  return html`
    <div className="flex items-center">
      <a href="/" className="text-2xl font-medium mr-5 focus-outline-blue">
        Uber
      </a>
      <div className="hidden lg:flex items-center">
        <${Dropdown} title="Company" hasChevron="${true}">
          ${[1, 2, 3, 4].map(
            (item) => html`
              <li key="{item}" className="dropdown-cell">
                <a href="#" className="px-3 py-1">
                  Item
                </a>
              </li>
            `
          )}
        <//>
        <${NavLinks} />
      </div>
    </div>
  `;
};

const BlockRight = ({ isSlideActive, setSlideActive, setActiveSlideDown }) => {
  const setSlide = (index, invert = false) => {
    setSlideActive(invert ? !isSlideActive : true);
    if (!isSlideActive) {
      setActiveSlideDown(index);
    } else {
      !invert && setActiveSlideDown(index);
    }
  };
  return html`
    <div className="flex items-center">
      <button
        type="button"
        className="hidden lg:flex mx-3 button button-black items-center"
        onClick="${() => setSlide(0)}"
      >
        <${GlobeIcon} />
        <span className="ml-2">EN</span>
      </button>

      <${ProductsDropdown} />
      <button type="button" className="button button-black flex items-center" onClick="${() => setSlide(1)}">
        <${PersonIcon} />
        <span className="hidden lg:inline ml-2">Log in</span>
      </button>
      <button type="button" className="button button-light ml-3" onClick="${() => setSlide(1)}">
        Sign up
      </button>
      <button
        type="button"
        className="button button-black ml-3 block lg:hidden"
        onClick="${() => setSlide(2, true)}"
        aria-label="Mobile Nav Toggle"
      >
        ${isSlideActive ? html`<${CloseIcon} />` : html`<${MenuIcon} />`}
      </button>
    </div>
  `;
};

const ProductsDropdown = () => {
  return html`
    <${Dropdown} icon="${html`<${GridIcon} />`}" title="Products" className="hidden lg:block">
      ${[1, 2, 3, 4, 5, 7, 8, 9, 10, 11, 12].map(
        (item) => html`
          <li key="${item}" className="dropdown-cell">
            <a href="#" className="px-5 py-3">
              <${GlobeIcon} />
              <span className="ml-2">Home</span>
            </a>
          </li>
        `
      )}
    <//>
  `;
};

const NavLinks = () => {
  const links = [
    { title: "Safety", href: "/safety" },
    { title: "Help", href: "/help" },
    { title: "COVID-19 resources", href: "/covid19" },
  ];
  return html`
    <div className="flex align-center">
      ${links.map((link, index) => html` <${LinkItem} link="${link}" index="${index}" key="${index}" /> `)}
    </div>
  `;
};

const LinkItem = ({ link, index }) => {
  return html`
    <a href="${link.href}" key="${index}" className="mx-3 button button-black text-white">
      ${link.title}
    </a>
  `;
};
